import {createSlice} from '@reduxjs/toolkit';
import {ClientDetailsDto} from 'src/shared/services/clients/dto/details-client-dto';

interface SignUpsInitialState {
  signUpDetails?: ClientDetailsDto;
  signUpsList?: Array<ClientDetailsDto>;
  isSignUpsListLoading?: boolean;
}

const initialState: SignUpsInitialState = {
  signUpDetails: undefined,
  signUpsList: [],
  isSignUpsListLoading: false,
};

const signUpsSlice = createSlice({
  name: 'signUps',
  initialState: initialState,
  reducers: {
    setSignUpDetails: (state, action) => {
      state.signUpDetails = action.payload;
    },
    setSignUpsList: (state, action) => {
      state.signUpsList = action.payload;
    },
    setIsSignUpsListLoading: (state, action) => {
      state.isSignUpsListLoading = action.payload;
    },
  },
});

export const {setSignUpDetails, setSignUpsList, setIsSignUpsListLoading} =
  signUpsSlice.actions;

export default signUpsSlice.reducer;
